var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 5C8.83505 4.99557 7.59629 5.50433 6.68181 6.41412C5.76733 7.32392 5.2522 8.56004 5.25 9.85V14.75C5.25 14.9489 5.32902 15.1397 5.46967 15.2803C5.61032 15.421 5.80109 15.5 6 15.5H7.75C8.16421 15.5 8.5 15.1642 8.5 14.75V9.85C8.49967 9.39056 8.69483 8.95269 9.03672 8.64578C9.37861 8.33888 9.83493 8.19193 10.2917 8.24167C11.13 8.34726 11.7566 9.06344 11.75 9.90833V14.75C11.75 15.1642 12.0858 15.5 12.5 15.5H14.25C14.6642 15.5 15 15.1642 15 14.75V9.85C14.9978 8.56004 14.4827 7.32392 13.5682 6.41412C12.6537 5.50433 11.415 4.99557 10.125 5Z",
    fill: "#007EBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5C0 6.08579 0.335786 5.75 0.75 5.75H3C3.41421 5.75 3.75 6.08579 3.75 6.5V14.75C3.75 15.1642 3.41421 15.5 3 15.5H0.75C0.335787 15.5 0 15.1642 0 14.75V6.5Z",
    fill: "#007EBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.375C3.75 3.41053 2.91053 4.25 1.875 4.25C0.839466 4.25 0 3.41053 0 2.375C0 1.33947 0.839466 0.5 1.875 0.5C2.91053 0.5 3.75 1.33947 3.75 2.375Z",
    fill: "#007EBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.1d09e9761c392d2ba0745d9c94733c40.svg";
export { ForwardRef as ReactComponent };